import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { REACT_APP_API_URL } from "../../../../../env";

const SettlementDetailsView = () => {
  const { ReleaseId } = useParams();
  const [blockDetails, setBlockDetails] = useState(null);
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSettlementData = async () => {
      try {
        const response = await axios.get(
          `${REACT_APP_API_URL}api/dashboard/admin/hotel-blocking/view-settlement_details/${ReleaseId}`
        );
        console.log("response.data.blockDetails", response.data.blockDetails);
        setBlockDetails(response.data.blockDetails);
        setPayments(response.data.payments);
      } catch (err) {
        console.error("Error fetching settlement data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchSettlementData();
  }, [ReleaseId]);

  if (loading) return <div className="text-center mt-4">Loading...</div>;

  if (!blockDetails)
    return <div className="alert alert-danger mt-4">No block data found.</div>;

  return (
    <div className="container-fluid admin-module-page py-4">
      <div className="admin-page-header mb-4">
        <span className="admin-page-kicker">Hotel Management</span>
        <h3 className="admin-page-title fw-bold mb-1">Block Settlement Details</h3>
        <p className="admin-page-description mb-0">
          Review the block summary and its payment trail.
        </p>
      </div>

      <div className="card admin-surface-card mb-4">
        <div className="card-header admin-surface-header">
          <h5 className="card-title mb-0">Block Summary</h5>
        </div>
        <div className="card-body admin-surface-body">
          <div className="row g-3">
            <div className="col-md-6">
              <div className="admin-detail-pill h-100">
                <div className="small text-muted mb-1">Customer Name</div>
                <div className="fw-semibold">{blockDetails.customer_name}</div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="admin-detail-pill h-100">
                <div className="small text-muted mb-1">Hotel</div>
                <div className="fw-semibold">{blockDetails.hotel_name}</div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="admin-detail-pill h-100">
                <div className="small text-muted mb-1">Block From</div>
                <div className="fw-semibold">
                  {blockDetails?.dtmBlockFromDate
                    ? blockDetails.dtmBlockFromDate.split("T")[0]
                    : ""}
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="admin-detail-pill h-100">
                <div className="small text-muted mb-1">Block To</div>
                <div className="fw-semibold">
                  {blockDetails?.dtmBlockToDate
                    ? blockDetails.dtmBlockToDate.split("T")[0]
                    : ""}
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="admin-detail-pill h-100">
                <div className="small text-muted mb-1">Blocked On</div>
                <div className="fw-semibold">
                  {blockDetails?.dtmCreated
                    ? blockDetails.dtmCreated.split("T")[0]
                    : ""}
                </div>
              </div>
            </div>
            <div className="col-12">
              <div className="admin-detail-pill">
                <div className="small text-muted mb-1">Remarks</div>
                <div className="fw-semibold">{blockDetails.vchRemarks}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="card admin-surface-card">
        <div className="card-header admin-surface-header d-flex justify-content-between align-items-center flex-wrap gap-2">
          <h5 className="card-title mb-0">Payment History</h5>
          <span className="admin-chip">
            <i className="bi bi-receipt"></i>
            {payments.length} payment{payments.length === 1 ? "" : "s"}
          </span>
        </div>
        <div className="card-body admin-surface-body">
          {payments.length === 0 ? (
            <div className="alert alert-warning mb-0">No payments found.</div>
          ) : (
            <div className="admin-table-shell">
              <table className="table table-striped table-hover align-middle mb-0">
                <thead className="table-light">
                  <tr>
                    <th>Amount Paid</th>
                    <th>Payment Date</th>
                    <th>Serial Number</th>
                    <th>Attachment</th>
                    <th>Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  {payments.map((pmt) => (
                    <tr key={pmt.intPaymentID}>
                      <td>â‚¹{pmt.amount_paid}</td>
                      <td>{new Date(pmt.payment_date).toLocaleDateString()}</td>
                      <td>{pmt.serial_number}</td>
                      <td>
                        {pmt.attachment_name ? (
                          <a
                            href={`${REACT_APP_API_URL}uploads/${pmt.attachment_name}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-decoration-none"
                          >
                            {pmt.attachment_name}
                          </a>
                        ) : (
                          "N/A"
                        )}
                      </td>
                      <td>{pmt.remarks || "â€”"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SettlementDetailsView;
